import { render, staticRenderFns } from "./AdGreetzModule.vue?vue&type=template&id=642a4a1e&"
import script from "./AdGreetzModule.ts?vue&type=script&lang=ts&"
export * from "./AdGreetzModule.ts?vue&type=script&lang=ts&"
import style0 from "./AdGreetzModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports